/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2022-2024 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { assign } from "lodash";
import { DataTableHeader } from "vuetify";

export interface vSelectItemInterface {
    disabled?: boolean
    divider?: boolean
    header?: string
    text?: string | number
    value?: string | number
}

export interface vDataTableFooterPropsInterface {
    'disable-items-per-page': boolean
    'disable-pagination': boolean
    'items-per-page-options': number[]
    'show-current-page': boolean
    'show-first-last-page': boolean
}

export function vDataTableFooterProps(props?: Partial<vDataTableFooterPropsInterface>): vDataTableFooterPropsInterface {
    return assign({
        'disable-items-per-page': false,
        'disable-pagination': false,
        'items-per-page-options': [10, 25, 50],
        'show-current-page': true,
        'show-first-last-page': true,
    } as vDataTableFooterPropsInterface, props || {})
}

export interface vColorPickersColor {
    alpha: number
    hex: string
    hexa: string
    hsla: {
        h: number
        s: number
        l: number
        a: number
    },
    hsva: {
        h: number
        s: number
        v: number
        a: number
    },
    hue: number
    rgba: {
        r: number
        g: number
        b: number
        a: number
    }
}

export type DefaultContainerModel = boolean | { icon?: string; message: string } | null

export function vDataTableHeaderHelperIcon(header: DataTableHeader): DataTableHeader {
    return assign(header, {
        align: "center",
        width: '56px',
    }) as DataTableHeader
}
